export const appButtons = [
    {
        appLink:
            'https://play.google.com/store/apps/details?id=io.hotdesk.app&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1',
        buttonImage:
            'https://hotdesk-assets.s3.eu-west-1.amazonaws.com/landing_pages/main_landing/google_play_store_icon.svg',
        colorButtonImage: {
            en: 'https://hotdesk-assets.s3.eu-west-1.amazonaws.com/landing_pages/main_landing/google_play_store_icon.svg',
            es: 'https://hotdesk-assets.s3.eu-west-1.amazonaws.com/landing_pages/web_v2/icons/es-google-play.png',
            ar: 'https://hotdesk-assets.s3.eu-west-1.amazonaws.com/landing_pages/main_landing/google_play_store_icon.svg'
        },
        alt: 'google_play_store',
        event: 'app_download_clicked'
    },
    {
        appLink:
            'https://apps.apple.com/us/app/hotdesk/id1484609853?ign-itscg=30200&ign-itsct=apps_box_badge',
        buttonImage:
            'https://hotdesk-assets.s3.eu-west-1.amazonaws.com/landing_pages/main_landing/app_store_icon.svg',
        colorButtonImage: {
            en: 'https://hotdesk-assets.s3.eu-west-1.amazonaws.com/landing_pages/main_landing/app_store_icon.svg',
            es: 'https://hotdesk-assets.s3.eu-west-1.amazonaws.com/landing_pages/web_v2/icons/es-Apple-store.svg',
            ar: 'https://hotdesk-assets.s3.eu-west-1.amazonaws.com/landing_pages/main_landing/app_store_icon.svg'
        },
        alt: 'app_store_icon',
        event: 'app_download_clicked'
    }
];
